module.exports = __webpack_public_path__ + "img/modal-noneed-icon.514467c4.svg";